<template>
  <div class="client-item-box new-list" :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex" :data-trackdata="tData">
    <div class="new-list-title" v-if="title">{{ title }}</div>
    <div class="new-list-banner" v-if="banner" :style="{'marginBottom': `${bannerGap}px`}" @click="moreAction">
      <beast-image
        class="img"
        :lazy="true"
        :image="banner"
        :containerWidth="boxWidth"
      />
    </div>
    <div class="new-list-box">
      <dynamic-list
        :dataOrigin="data.dataOrigin"
        :ids="data.ids || []"
        :listCondition="listCondition"
        :miniEnv="miniEnv"
        :listPl="data.paddingData.pl"
        @product-simple="productSimpleJump"
      />
    </div>
    <div class="new-list-button" v-if="buttonName" @click="moreAction">{{ buttonName }}</div>
  </div>
</template>

<script>

import beastImage from '@/components/image'
import dynamicList from '@/components/dynamic-product-list'

import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getLinkPageData } from '@/link'

const clientWidth = getClientWidth()
const ratio = clientWidth/375

export default {
  name: 'list',
  props: ['data', 'sdk', 'miniEnv'],
  components: {
    beastImage,
    dynamicList
  },
  data () {
    return {
      styleCondition: null,
      title: null,
      banner: null,
      bannerGap: null,
      buttonName: null,
      boxWidth: 0,
      listCondition: null,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  created () {
    this.formatData()
  },
  mounted () {
  },
  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  methods: {
    formatData () {
      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb
      const {
        pl,
        pr
      } = this.data.paddingData

      this.boxWidth = (375-pl-pr)*ratio
      this.title = this.data.title
      if(this.data.banner && this.data.banner.src) {
        this.bannerGap = this.data.bannerGap?Number(this.data.bannerGap)*ratio:0
        this.banner = this.data.banner
      }
      this.buttonName = this.data.moreButton || ''

      this.listCondition = {
        listWidth: this.boxWidth,
        lineGap: this.data.lineGap?Number(this.data.lineGap)*ratio:2,
        rowGap: this.data.rowGap?Number(this.data.rowGap)*ratio:34,
        rowNum: this.data.rowNum?Number(this.data.rowNum):2,
        soldOutCondition: this.data.soldOutCondition || 'BOTTOM',
        productName: this.data.productName,
        brandName: this.data.brandName,
        rawPrice: this.data.rawPrice,
        nowPrice: this.data.nowPrice,
        ratio
      }
    },
    moreAction () {
      const link = this.data.link
      if(!link.type || link.type === 'none') {
        return
      }

      const trackData = this.data.trackData
      trackData.operation_name = this.buttonName
      trackAction({
        trackData: trackData,
        pageObj: getLinkPageData({link})
      })

      normalSkip({
        // trackData: {
        //   name: 'new-list-more',
        //   attrs: {
        //     index: this.newListIndex
        //   },
        //   wait: false
        // },
        link: transformLink({
          link,
          isMini: this.miniEnv
        }),
        isMini: this.miniEnv
      })
    },
    productSimpleJump (product, index) {
      const trackData = this.data.trackData
      const link = {
        type: 'product',
        value: product.id
      }
      trackData.module_number=index-0+1

      sa.track('CommodityClick', {
        position_number: index-0+1,
        commodity_spu_id: product.id,
        commodity_name: product.name,
        original_price: product.rawPrice,
        discount_price: product.price,
        commodity_need_point: product.point || 0,
        business_case: '其他'
      })

      trackAction({
        trackData: trackData,
        pageObj: getLinkPageData({
          link,
          title: product?product.name:''
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// new-list.vue?2eaa9f49